import { __awaiter, __generator } from "tslib";
import { getSharedContext } from '../getSharedContext';
import { resolveSharedContext } from '../resolveSharedContext';
export var sharedContextConfigOptions = {
    key: 'SharedContext',
    isGetClientGeneratedConfigEnabled: function (featureGates) {
        var _a;
        return !!((_a = featureGates.sharedContextNorthStarGates) === null || _a === void 0 ? void 0 : _a.sharedContextNorthStarEnabled);
    },
    getClientGeneratedConfig: resolveSharedContext,
    getServerGeneratedConfig: function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var sharedContext;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getSharedContext(context)];
                case 1:
                    sharedContext = _a.sent();
                    if (context.inMockMode && sharedContext) {
                        sharedContext.graphApiRoot = "http://localhost:".concat(process.env.MOCK_API_PORT_NUMBER || 5000).concat(sharedContext.graphApiRoot);
                    }
                    return [2 /*return*/, sharedContext];
            }
        });
    }); },
};
//# sourceMappingURL=sharedContextConfigOptions.js.map